import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  addDoc,
  onSnapshot,
  updateDoc,
  deleteDoc,
  doc,
  getDocs,
  query,
  orderBy,
} from "firebase/firestore";

export default function Offers() {
  const [members, setMembers] = useState([]);
  const [offers, setOffers] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedMember, setSelectedMember] = useState(null);

  const [amount, setAmount] = useState("");
  const [message, setMessage] = useState("");

  // 🔹 Load Members
  useEffect(() => {
    const loadMembers = async () => {
      const snap = await getDocs(collection(db, "members"));
      setMembers(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    };
    loadMembers();
  }, []);

  // 🔹 Load Offers (Table data)
  useEffect(() => {
    const q = query(collection(db, "offers"), orderBy("createdAt", "desc"));
    return onSnapshot(q, snap => {
      setOffers(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });
  }, []);

  // 🔹 Create Offer
  const createOffer = async () => {
    if (!selectedMember || !amount) {
      alert("Member & Amount required");
      return;
    }

    await addDoc(collection(db, "offers"), {
      memberId: selectedMember.memberId,
      name: selectedMember.name,
      mobile: selectedMember.mobile,
      amount: Number(amount),
      message,
      status: "OPEN",
      createdAt: new Date(),
    });

    setAmount("");
    setMessage("");
    alert("Offer Created ✅");
  };

  // 🔹 Toggle Status
  const toggleStatus = async (id, status) => {
    await updateDoc(doc(db, "offers", id), {
      status: status === "OPEN" ? "CLOSED" : "OPEN",
    });
  };

  // 🔹 Delete Offer
  const deleteOffer = async (id) => {
    if (window.confirm("Delete this offer?")) {
      await deleteDoc(doc(db, "offers", id));
    }
  };

  // 🔹 Download Excel
  const downloadExcel = () => {
    let csv = "Member ID,Name,Mobile,Amount,Message,Status,Date\n";
    offers.forEach(o => {
      const date = o.createdAt?.toDate().toLocaleDateString();
      csv += `${o.memberId},${o.name},${o.mobile},${o.amount},${o.message},${o.status},${date}\n`;
    });

    const blob = new Blob([csv], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "offers.csv";
    link.click();
  };

  // 🔹 Download PDF (simple)
  const downloadPDF = () => {
    window.print();
  };

  return (
    <div style={{ padding: 20 }}>

      {/* ================= CREATE OFFER ================= */}
      <div className="card">
        <h2>Create Offer</h2>

        <input
          placeholder="Search Member ID / Name / Mobile"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />

        {search && (
          <div className="dropdown">
            {members
              .filter(m =>
                `${m.memberId} ${m.name} ${m.mobile}`
                  .toLowerCase()
                  .includes(search.toLowerCase())
              )
              .map(m => (
                <div
                  key={m.id}
                  onClick={() => {
                    setSelectedMember(m);
                    setSearch("");
                  }}
                >
                  {m.memberId} - {m.name} - {m.mobile}
                </div>
              ))}
          </div>
        )}

        <input value={selectedMember?.memberId || ""} placeholder="Member ID" disabled />
        <input value={selectedMember?.name || ""} placeholder="Member Name" disabled />
        <input value={selectedMember?.mobile || ""} placeholder="Mobile" disabled />

        <input
          placeholder="Offer Amount"
          value={amount}
          onChange={e => setAmount(e.target.value)}
        />

        <input
          placeholder="Message"
          value={message}
          onChange={e => setMessage(e.target.value)}
        />

        <button className="green-btn" onClick={createOffer}>
          CREATE OFFER
        </button>
      </div>

      {/* ================= DOWNLOAD BUTTONS ================= */}
      <div style={{ marginTop: 30 }}>
        <button onClick={downloadPDF}>Download PDF</button>
        <button onClick={downloadExcel} style={{ marginLeft: 10 }}>
          Download Excel
        </button>
      </div>

      {/* ================= OFFER TABLE ================= */}
      <h2 style={{ marginTop: 20 }}>Offers Table</h2>

      <table>
        <thead>
          <tr>
            <th>Member ID</th>
            <th>Name</th>
            <th>Mobile</th>
            <th>Amount</th>
            <th>Message</th>
            <th>Status</th>
            <th>Date</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {offers.map(o => (
            <tr key={o.id}>
              <td>{o.memberId}</td>
              <td>{o.name}</td>
              <td>{o.mobile}</td>
              <td>₹ {o.amount}</td>
              <td>{o.message}</td>
              <td>{o.status}</td>
              <td>{o.createdAt?.toDate().toLocaleDateString()}</td>
              <td>
                <button onClick={() => toggleStatus(o.id, o.status)}>
                  Open / Close
                </button>
                <button className="delete" onClick={() => deleteOffer(o.id)}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* ================= STYLES ================= */}
      <style>{`
        input {
          width: 100%;
          padding: 8px;
          margin: 6px 0;
        }

        .card {
          background: #fff;
          padding: 20px;
          border-radius: 8px;
          box-shadow: 0 0 10px #ccc;
          max-width: 600px;
        }

        .green-btn {
          width: 100%;
          padding: 12px;
          background: linear-gradient(green, darkgreen);
          color: white;
          border: none;
          font-size: 16px;
          border-radius: 30px;
          cursor: pointer;
        }

        table {
          width: 100%;
          border-collapse: collapse;
        }

        th, td {
          border: 1px solid #ccc;
          padding: 8px;
        }

        .delete {
          background: red;
          color: white;
          margin-left: 5px;
        }

        .dropdown {
          border: 1px solid #ccc;
          background: white;
          max-height: 150px;
          overflow: auto;
        }

        .dropdown div {
          padding: 5px;
          cursor: pointer;
        }

        .dropdown div:hover {
          background: #eee;
        }
      `}</style>
    </div>
  );
}